import axios from '@/plugins/axios'

export default {
  fetch(params) {
    return axios.get('streams', { params }).then(result => result.data)
  },
  get(id) {
    return axios.get(`streams/${id}`).then(result => result.data)
  },
  update(id, data) {
    return axios.patch(`streams/${id}`, data).then(result => result.data)
  },
  create(data) {
    return axios.post('streams', data).then(result => result.data)
  },
  release(id) {
    return axios.get(`streams/${id}/release`).then(result => result.data)
  },
  uploadImage(id) {
    return axios.get(`streams/${id}/upload-image`).then(result => result.data)
  },
  sync(playerIds) {
    return axios.post('streams/sync', {
      player_ids: playerIds
    }).then(result => result.data)
  },
  restart(playerIds, type) {
    return axios.post('streams/restart', {
      player_ids: playerIds,
      type
    }).then(result => result.data)
  }

}
